import { render, staticRenderFns } from "./SurveyAI.vue?vue&type=template&id=bc804f1e&"
import script from "./SurveyAI.vue?vue&type=script&lang=js&"
export * from "./SurveyAI.vue?vue&type=script&lang=js&"
import style0 from "./SurveyAI.vue?vue&type=style&index=0&id=bc804f1e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports